<template>
    <div>
        <h3 class="color_Azul family-01 mb-3">Presentación</h3>
        <hr class="divider-02 hr-sm-left-0 bg-color">
        <h6 class="color8">Título que se otorga: {{licenciatura.Titulo}}</h6>
        <h6 class="color8">Duración: {{licenciatura.Duracion}}</h6>
        <h6 class="color8 mb-5">Sistema Escolarizado: {{licenciatura.Sistema}}</h6>
        <p class="mb-3 list-icon" v-html="licenciatura.Descripcion">
        </p>
        <div v-for="(item, index) in licenciatura.archivos" :key="index">
            <img :src="licenciatura.RutaFile+item.Archivo" class="w-100 img-thumbnail mb-3" alt="ENES">
        </div>
    </div>
</template>

<script>
export default {
    name:'Introduccion',
    props:["licenciatura"],
    data() {
        return {
        }
    },
    methods: {
    },
    created() {
    },
}
</script>